import { AfterViewInit, Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NavigationStart, ResolveStart, Router } from '@angular/router';
import { HeaderButtonComponent } from './header-button/header-button.component';
import { UiService } from '../../services/ui.service';
import { AuthenticationService } from '../../modules/auth/services/authentication.service';
import { CurrentUser } from '../../modules/auth/model/CurrentUser';
import { MessagingService } from '../../services/messaging.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NotificationCreateDialogComponent } from '../../dialog/notifications/notification-create-dialog/notification-create-dialog.component';
import { ChatService } from '../../services/messaging/chat.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { SignalrService } from '../../services/socket/signalr.service';
import { NotificationService } from '../../services/messaging/notification.service';
import { NotificationDataModel } from '../../models/messaging/notification-data.model';
import { isIterable, not } from 'rxjs/internal-compatibility';
import { TaskManagementDialogComponent, TaskQueryModel } from '../../dialog/tasks/task-management-dialog/task-management-dialog.component';
import { SystemTaskDataModel } from '../../models/messaging/system-task-data.model';
import { TaskService } from '../../services/task.service';
import { Globals } from '../../globals';
import { StaticDataService } from '../../services/static-data.service';
import { UserRoleEnum } from '../../models/enum/user-role.enum';
import { InternalMessagingDialogComponent } from '../../dialog/notifications/internal-messaging-dialog/internal-messaging-dialog.component';
import { InternalEmailService } from '../../services/messaging/internal-email.service';
import { InternalEmailDataModel } from '../../models/communication/internal-email-data.model';
import { NotificationDestinationDataModel } from '../../models/messaging/notification-destination-data.model';
import { ColorSchemeDataModel } from '../../models/configuration/color-scheme-data.model';
import { ColorSchemesService } from '../../modules/configuration/color-schemes/color-schemes.service';
import { TdoUserConfigurationModel } from '../../models/configuration/user/tdo-user-configuration.model';
import { UserService } from '../../services/user.service';
import { TDOTaskListService } from "../controls/tdo-task-list/tdo-task-list.service";


@Component({
  selector: 'app-tdo-header',
  templateUrl: './tdo-header.component.html',
  styleUrls: ['./tdo-header.component.scss']
})
export class TdoHeaderComponent implements OnInit, AfterViewInit {
  @ViewChildren(HeaderButtonComponent) middleButtons: QueryList<HeaderButtonComponent>;

  isShowButtons: boolean = true;
  isShowMenu: boolean = false;
  isShowNotifications: boolean = false;

  currentUser: CurrentUser;
  currentPatient: CurrentUser;
  userMode: string = 'user';

  //userTaskTypeEnums: EnumValidValueItemModel[] = [];
  tasks: SystemTaskDataModel[] = [];
  tasksCalls: SystemTaskDataModel[] = [];
  tasksReports: SystemTaskDataModel[] = [];
  tasksOthers: SystemTaskDataModel[] = [];
  internalEmails: InternalEmailDataModel[] = [];

  taskQueryModel = new TaskQueryModel();

  //queuedMeds: number = null;
  totalNotifications: number = null;
  numNewNotifications = 0;
  // numPages: number = 0;
  pages: NotificationDestinationDataModel[] = [];
  instantMessages: NotificationDestinationDataModel[] = [];

  colorSchemes: ColorSchemeDataModel[] = [];
  users: TdoUserConfigurationModel[] = [];
  headerTitle: string = null;
  loadingInfo: boolean = false;

  constructor(private router: Router,
    private globals: Globals,
    private dialog: MatDialog,
    public uiService: UiService,
    private authService: AuthenticationService,
    private messagingService: MessagingService,
    private localStorageService: LocalStorageService,
    private signalrService: SignalrService,
    public notificationService: NotificationService,
    private authenticationService: AuthenticationService,
    private staticDataService: StaticDataService,
    private internalEmailService: InternalEmailService,
    public taskService: TaskService,
    public chatService: ChatService,
    private userService: UserService,
    private colorSchemeService: ColorSchemesService,
    private TaskListService: TDOTaskListService) {
    this.authService.currentUser.subscribe(userObj => {
      this.currentUser = userObj;
      if (userObj) {
        this.currentPatient = null;
        const isReferrerRole = localStorage.getItem('isReferrerRole');
        if (isReferrerRole && isReferrerRole === 'true')
          this.userMode = 'referrer';
        else
          this.userMode = 'user';
      }
    });

    this.authService.currentPatient.subscribe(patientObj => {
      this.currentPatient = patientObj;

      if (patientObj) {
        this.currentUser = null;
        this.userMode = 'patient';
      }
    });
  }

  // setupEnums() {
  //   this.userTaskTypeEnums = this.staticDataService.getValidValueItemsByValidValueName('enumUserTaskType');
  // }

  ngOnInit(): void {
    if (this.authenticationService.currentUserValue && this.userMode == 'user') {
      this.userService.getUsers(this.authenticationService.currentUserValue?.TDOCID).subscribe((users) => {
        this.users = users;
      });
    }
    if (this.authenticationService.currentUserValue) {
      this.colorSchemeService.getColorSchemes().subscribe((cs) => {
        this.colorSchemes = cs;
      });
    }

    // if (this.staticDataService.isReady) {
    //   this.setupEnums();
    // } else {
    //   this.staticDataService.validValuesReadyEvent.subscribe({
    //     complete: () => this.setupEnums()
    //   });
    // }

    this.router.events.subscribe((data) => {
      if (data instanceof NavigationStart || data instanceof ResolveStart) {
        const ivl = setInterval(() => {
          if (this.middleButtons && isIterable(this.middleButtons)) {
            this.resetButtons();
            clearInterval(ivl);

            if (data.url === '/' || data.url.includes('login') || data.url.includes('configuration') || data.url.includes('scheduler')
              || data.url.includes('forms/builder') || data.url.includes('studio') || data.url.includes('reports')) {
              this.isShowButtons = false;
              if (data.url.includes('scheduler')) this.headerTitle = "Calendar";
              if (data.url.includes('configuration')) this.headerTitle = "Settings";
            }
            else {
              this.isShowButtons = true;
              if (data.url.includes('landing')) {
                const selectedButton = this.middleButtons.find(p => p.name === 'home');
                if (selectedButton) {
                  selectedButton.isSelected = true;
                }
              } else if (data.url.includes('scheduler')) {
                const selectedButton = this.middleButtons.find(p => p.name === 'calendar');
                if (selectedButton) {
                  selectedButton.isSelected = true;
                }
              } else if (data.url.includes('patientportal')) {
                this.isShowButtons = false;
                this.headerTitle = "Patient Portal";
              } else if (data.url.includes('referrerportal')) {
                this.isShowButtons = false;
                this.headerTitle = "Referrer Portal";
              }
            }
            if (this.isShowButtons && !this.loadingInfo) { //only retrieve tasks and info when buttons are shown
              this.loadingInfo = true;
              this.getInstantMessages();
              this.getTasks();
              this.getInternalEmails();
            }
          }
        }, 100);
      }
    });


    this.signalrService.messageUser.subscribe((res) => {
      switch (res.messageType) {
        case SignalrService.UPDATE_PAGES:
          // this.getPages();
          const dest = JSON.parse(res.message as unknown as string) as NotificationDestinationDataModel;
          if (dest && dest.UserID.toLowerCase() === this.authenticationService.currentUserValue.authdata?.userid.toLowerCase()) {
            this.playSound(dest.UserID);
          }
          break;
        case SignalrService.PAGE_SEEN:
          const dest1 = JSON.parse(res.message as unknown as string) as NotificationDestinationDataModel;
          const idx = this.pages.findIndex(p => p.dataNotification.NotificationID === dest1.NotificationID);
          if (idx > -1) {
            this.pages.splice(idx, 1);
            this.numNewNotifications--;
          }
          break;
        case SignalrService.UPDATE_CHAT_MESSAGE:
          this.getInstantMessages();
          break;
        case 'UPDATE_NOTIFICATIONS':
          break;
        case 'UPDATE_INTERNAL_EMAIL':
          this.getInternalEmails();
          break;
        case 'UPDATE_TASKS':
          this.taskService.getTasks(this.taskQueryModel).subscribe((taskRes) => {
            this.tasks = taskRes;
            this.calculateNumNotifications();
            // this.numNewNotifications += taskRes.length;
          });
          break;
      }
    });
  }

  getInstantMessages() {
    if (this.authenticationService.currentUserValue) {
      this.notificationService.getMessagesForUser(this.authenticationService.currentUserValue?.authdata?.userid).subscribe((notifications) => {
        this.instantMessages = notifications;
        this.instantMessages = this.instantMessages.sort((a, b) => {
          const da = new Date(a.xauditModifiedOn);
          const db = new Date(a.xauditModifiedOn);
          return db.getTime() - da.getTime();
        });
        this.calculateNumNotifications();
      });
    }
  }

  getTasks() {
    if (this.TaskListService.tasks.getValue().length === 0) {
      this.TaskListService.loadTaskList();
    }
  }

  removeItemTask(taskId: string) {
    const index: number = this.tasks.findIndex(x => x.SystemTaskId === taskId);
    this.tasks.splice(index, 1);
  }

  parseJson(jsonString: string) {

    return JSON.parse(jsonString.replace(/'/g, '"'));
  }

  getInternalEmails() {
    if (this.authService.currentUserValue) {
      this.internalEmailService.getUnreadEmails(this.authService.currentUserValue.authdata.userid).subscribe((ieRes) => {
        this.internalEmails = ieRes;
        this.calculateNumNotifications();
      });
    }
  }

  calculateNumNotifications() {
    this.numNewNotifications = 0;
    this.numNewNotifications += this.tasks.length;
    this.numNewNotifications += this.internalEmails.length;
  }

  onLogoClick() {
    if (this.userMode === 'user' && !this.isShowButtons)
      window.close();
    else if (this.userMode === 'user')
      this.navigateTo('/landing');
    else if (this.userMode === 'referrer')
      this.navigateTo('/referrerportal/home');
    else
      this.navigateTo('/patientportal/home');
  }

  onNotificationsClick() {
    this.isShowNotifications = !this.isShowNotifications;
  }

  onUserProfileClick() {
    this.isShowMenu = !this.isShowMenu;
  }

  private navigateTo(path: string) {
    this.router.navigateByUrl(path);
  }

  ngAfterViewInit(): void {
    const selectedButton = this.middleButtons.find(p => p.name === 'home');
    if (selectedButton) {
      selectedButton.isSelected = true;
    }
  }

  onMiddleButtonClick(event) {
    const clicked = event as HeaderButtonComponent;
    if (clicked.isPage) {
      this.resetButtons();
      clicked.isSelected = true;
    }



    switch (clicked.name) {
      case 'home':
        this.navigateTo('/landing');
        break;
      case 'search':
        // this.navigateTo('/landing');
        break;
      case 'video':
        // this.navigateTo('/landing');
        break;
      case 'notes':
        // this.navigateTo('/landing');
        break;
      case 'communication':
        this.messagingService.sendComponentMessage('Toggle-Live-Chat-Display', {});
        break;
      case 'calendar':
        const calendarUrl = this.router.serializeUrl(
          this.router.createUrlTree(['/scheduler'])
        );
        let windowOptions = [
          'toolbar=no',
          'location=no',
          'menubar=no',
          'height=' + screen.height,
          'width=' + screen.width,
          'fullscreen=yes' // only works in IE, but here for completeness
        ].join(',');
        let storageName = 'tdoProCalendarWindow';
        let itemToStore = {};
        let postClosureEvents = [];
        let tdoProCalendarWindowId = this.messagingService.openPopUpWindow(calendarUrl, windowOptions, storageName, itemToStore, postClosureEvents, true, 'tdoProCalendarWindow');

        //window.open(calendarUrl, 'tdoProCalendarWindow');
        //this.navigateTo('/scheduler');
        break;

      case 'z-calendar':
        const zcalendarUrl = this.router.serializeUrl(
          this.router.createUrlTree(['/tdo-scheduler'])
        );
        let zwindowOptions = [
          'toolbar=no',
          'location=no',
          'menubar=no',
          'height=' + screen.height,
          'width=' + screen.width,
          'fullscreen=yes' // only works in IE, but here for completeness
        ].join(',');
        let zstorageName = 'tdoProCalendarWindow';
        let zitemToStore = {};
        let zpostClosureEvents = [];
        let ztdoProCalendarWindowId = this.messagingService.openPopUpWindow(zcalendarUrl, zwindowOptions, zstorageName, zitemToStore, zpostClosureEvents, true, 'tdoProzCalendarWindow');

        break;


      case 'pid':
        this.uiService.openPidWindow();
        break;
      case 'comms':
        this.uiService.openCommsWindow();
        break;
    }
  }

  onProfileClick() {
    this.isShowMenu = false;
    if (this.userMode == 'user')
      this.router.navigateByUrl('configuration/practice-users');
    else
      this.router.navigateByUrl('patientportal/profile');
  }

  onTitleClick() {
    this.onLogoClick();

  }

  onSettingsClick() {
    this.isShowMenu = false;
    //this.router.navigateByUrl('configuration');
    const settingsUrl = this.router.serializeUrl(
      this.router.createUrlTree(['/configuration'])
    );
    let windowOptions = [
      'toolbar=no',
      'location=no',
      'menubar=no',
      'height=' + screen.height,
      'width=' + screen.width,
      'fullscreen=yes' // only works in IE, but here for completeness
    ].join(',');
    let storageName = 'tdoProConfigurationWindow';
    let itemToStore = {};
    let postClosureEvents = [];
    let tdoProCalendarWindowId = this.messagingService.openPopUpWindow(settingsUrl, windowOptions, storageName, itemToStore, postClosureEvents, true, 'tdoProConfigurationWindow');
  }

  onFeeScheduleClick() {
    this.isShowMenu = false;
    this.router.navigateByUrl('fee-schedule');
  }

  onLogoutClick(event: any) {
    this.isShowMenu = false;
    this.authService.logout();
    let loginRoute = '/login';
    let returnUrl = '/';
    if (this.userMode === 'patient') {
      loginRoute = '/patientLogin';
      returnUrl = '/patientportal/home';
    }
    else if (this.userMode === 'referrer') {
      loginRoute = '/referrerLogin';
      returnUrl = '/referrerportal/home';
    }

    this.messagingService.alertChildrenOnClosure();
    this.uiService.closePopupWindows();
    this.router.navigate([loginRoute], { queryParams: { returnUrl, tdoDialog: false } });
  }

  private resetButtons() {
    for (const b of this.middleButtons) {
      b.isSelected = false;
      b.isHovered = false;
    }
  }

  onOpenInstantMessaging(destination: NotificationDestinationDataModel = null) {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    config.data = destination;
    this.dialog.open(NotificationCreateDialogComponent, config);
  }

  onNotificationSeenClick(notification: NotificationDataModel, isPage = false) {
    if (isPage) {
      const page = this.pages.find(p => p.dataNotification.NotificationID === notification.NotificationID);
      if (page) {
        if (page.UserID.toLowerCase() !== this.authenticationService.currentUserValue.authdata.userid.toLowerCase()) {
          return;
        }
      }
    }

    this.notificationService.markNotificationAsSeen(notification).subscribe((res) => {
      let idx = -1;
      if (isPage) {
        idx = this.pages.findIndex(p => p.dataNotification.NotificationID === notification.NotificationID);
        if (idx > -1) {
          this.pages.splice(idx, 1);
          this.numNewNotifications--;
        }
      } else {
        idx = this.instantMessages.findIndex(p => p.dataNotification.NotificationID === notification.NotificationID);
        if (idx > -1) {
          this.instantMessages.splice(idx, 1);
          this.numNewNotifications--;
        }
      }
    });
  }

  onOpenNotificationToFrontDialog() {
    this.router.navigateByUrl('landing/notes-to-front');
  }

  onOpenTaskManagementDialog() {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    this.dialog.open(TaskManagementDialogComponent, config);
  }

  getDate(date: Date | string) {
    const da = new Date(date);
    return da.toLocaleString();
  }

  isPastDue(task: SystemTaskDataModel) {
    const taskDueDate = new Date(task.DueDate);
    return taskDueDate < new Date();
  }

  isHasRole(val: string) {
    switch (val) {
      case 'communication':
        return this.authenticationService.currentUserRolesIds.includes(UserRoleEnum.Communications);
      case 'scheduler':
        return this.authenticationService.currentUserRolesIds.includes(UserRoleEnum.Scheduler);
      case 'noteToFront':
        return this.authenticationService.currentUserRolesIds.includes(UserRoleEnum.NoteToFront);
    }

    return false;
  }

  onInternalCommunicationClick() {
    const config = new MatDialogConfig();
    config.panelClass = 'dialog';
    this.dialog.open(InternalMessagingDialogComponent, config).afterClosed().subscribe((res) => {

    });
  }

  markInternalEmailAsRead(email: InternalEmailDataModel) {
    const myDestination = email.dataInternalEmailDestanations.find(p => p.UserID === this.authService.currentUserValue.authdata.userid);
    if (myDestination) {
      this.internalEmailService.markAsRead(myDestination.IEmailToID).subscribe(() => {
        const idx = this.internalEmails.findIndex(p => p === email);
        if (idx > -1) {
          this.internalEmails.splice(idx, 1);
          this.numNewNotifications--;
        }
      });
    }
  }

  getBackgroundColor(userId: string) {
    const user = this.users.find(p => p.UserID.toLowerCase() === userId.toLowerCase());
    if (user) {
      const scheme = this.colorSchemes.find(p => p.ColorSchemeId.toLowerCase() === user.ColorSchemeID.toLowerCase());
      if (scheme) {
        return scheme.BackColor;
      }
    }
  }

  getForColor(userId: string) {
    const user = this.users.find(p => p.UserID.toLowerCase() === userId.toLowerCase());
    if (user) {
      const scheme = this.colorSchemes.find(p => p.ColorSchemeId.toLowerCase() === user.ColorSchemeID.toLowerCase());
      if (scheme) {
        return scheme.ForeColor;
      }
    }
  }

  getName(userId: string) {
    const user = this.users.find(p => p.UserID.toLowerCase() === userId.toLowerCase());
    if (user) {
      return user.FirstName + ' ' + user.LastName;
    }
  }

  playSound(userId: string) {
    const user = this.users.find(p => p.UserID.toLowerCase() === userId.toLowerCase());
    if (user) {
      const audio = new Audio();
      audio.src = 'assets/sounds/user/' + user.UserSound;
      audio.load();
      audio.play();
    }
  }

  getContactByDate(xauditModifiedOn: Date) {
    const today = new Date();
    const d = new Date(xauditModifiedOn);
    if (today.getDate() === d.getDate()) {
      const time = d.toLocaleTimeString();
      return `Today @ ${time}`;
    } else {
      return d.toLocaleString();
    }
  }
}
